import { render, staticRenderFns } from "./VenScLAddress.vue?vue&type=template&id=3feb87d0"
import script from "./VenScLAddress.vue?vue&type=script&lang=js"
export * from "./VenScLAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports